module.exports = __webpack_public_path__ + "static/media/winSmall60_1.e8f89c48.svg";